export default "/048cb1f2b29308e18768c65cfd51e426596a830c/0c7f90dcab4574f291a5b93f31621815.svg";